import { withAccount } from '@/components/AcountLayout';
import { Flex, Grid, GridAutoFit } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { IconCta } from '@/components/IconCta';
import { Section } from '@/components/Section';
import { useModal } from '@/hooks/useModal';
import { isProfileComplete } from '@/resource/profile';
import { routeToPath } from '@/util/routeToPath';
import { staticProps } from '@/util/staticProps';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default withAccount(function Account({ sections, profile }) {
  const { open } = useModal();
  const { push } = useRouter();
  const isIncomplete = !isProfileComplete(profile);

  useEffect(() => {
    if (isIncomplete) {
      open(
        {
          type: 'message',
          props: {
            title: 'Je profiel is nog niet compleet',
            description:
              'Kijk alsjeblieft na of je je achternaam, postcode en profielfoto al hebt ingesteld.',
          },
        },
        () => {
          push(routeToPath({ type: 'profile_info' }));
        }
      );
    }
  }, [isIncomplete, push, open]);

  return (
    <>
      <NextSeo title="Account" />
      <Section>
        <Grid
          columns={{ xl: sections.length === 2 ? [6, 6] : [4, 4, 4] }}
          gap={{ sm: 4, lg: 3 }}
        >
          {sections.map((section) => (
            <Flex dir="column" gap={4} key={section.title}>
              <Heading align="center">{section.title}</Heading>
              <GridAutoFit gap={{ sm: 2, md: 3 }} minColumnWidth={400}>
                {section.items
                  .filter((item) => !item.disabled)
                  .map((item) => (
                    <IconCta
                      key={item.title}
                      icon={item.icon}
                      to={item.to}
                      title={item.title}
                      description={item.description}
                      prefetchQuery={item.prefetchQuery}
                      onClick={item.onClick}
                      unseenCount={item.unseenCount}
                    />
                  ))}
              </GridAutoFit>
            </Flex>
          ))}
        </Grid>
      </Section>
    </>
  );
});

export const getStaticProps = staticProps.resolve(async () => {
  return {
    props: {},
    revalidate: 10,
  };
});
